// extracted by mini-css-extract-plugin
export default {"waiting-room-mute-button-muted":"global_waiting-room-mute-button-muted__iF3zx","anticon":"global_anticon__z5AUo"};